const AudioContext = window.AudioContext || window.webkitAudioContext;
const audioCtx = new AudioContext();
export default audioCtx;
